module.exports = __webpack_public_path__ + "img/sidebar_admiral_202627.6286e9ca.png";